module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image11.3d41dbf8.jpg";